import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_STISCListReverseScan = _resolveComponent("STISCListReverseScan")!
  const _component_STISCListV1 = _resolveComponent("STISCListV1")!

  return (_ctx.isReverseScanSTISC)
    ? (_openBlock(), _createBlock(_component_STISCListReverseScan, { key: 0 }))
    : (_openBlock(), _createBlock(_component_STISCListV1, { key: 1 }))
}